import {storeInstance} from '@aofl/store/dist/legacy';
import {routerInstance} from '@aofl/router';
import {sdoNs} from './constants-enumerate';
import {SearchParams} from './search-url-params';
import {deepAssign} from '@aofl/object-utils';
import {environment} from '@modules/constants-enumerate';

const resetFilters = (searchNamespace = sdoNs.GROUP_SEARCH) => {
  const state = storeInstance.getState();
  const filters = state[searchNamespace].defaultQueryObj.filters;

  storeInstance.commit({
    namespace: searchNamespace,
    mutationId: 'setQueryFilters',
    payload: filters
  }, {
    namespace: searchNamespace,
    mutationId: 'setPendingFilters',
    payload: filters
  });

  /** @todo decide if we need to reload the page or not */
  const searchState = storeInstance.getState()[searchNamespace];
  searchState.queryObj.filters_reset = true;
  const searchParams = SearchParams.encode(searchState.queryObj);
  const searchTargetUrl = state[searchNamespace].searchTargetUrl;

  try {
    routerInstance.navigate(`${searchTargetUrl}?${searchParams}`, {
      replaceState: true
    });
  } catch (e) {
  }
};

const maybeApplyFilters = async (searchNamespace) => {
  await applyFilters(searchNamespace);
  return true;
};

const applyFilters = async (searchNamespace = sdoNs.GROUP_SEARCH) => {
  const state = storeInstance.getState();
  const queryObj = state[searchNamespace].queryObj;
  const pendingFilters = state[searchNamespace].pendingFilters;
  let searchQuery = queryObj;
  if (typeof pendingFilters !== 'undefined') {
    searchQuery = deepAssign(queryObj, 'filters', pendingFilters);
  }

  storeInstance.commit(
    {namespace: searchNamespace, mutationId: 'setQueryObj', payload: searchQuery},
    {namespace: searchNamespace, mutationId: 'removeSortLastValues'}
  );

  const searchParams = SearchParams.encode(searchQuery);
  const searchTargetUrl = state[searchNamespace].searchTargetUrl;

  try {
    const url = `${searchTargetUrl}?${searchParams}`;
    window.history.replaceState('', '', url);
  } catch (e) {}
};


const applyHistory = (searchNamespace = sdoNs.GROUP_SEARCH) => {
  const state = storeInstance.getState();
  const queryObj = state[searchNamespace].queryObj;
  const pendingFilters = state[searchNamespace].pendingFilters;
  let searchQuery = queryObj;
  if (typeof pendingFilters !== 'undefined') {
    searchQuery = deepAssign(queryObj, 'filters', pendingFilters);
  }

  const searchParams = SearchParams.encode(searchQuery);
  const searchTargetUrl = state[searchNamespace].searchTargetUrl;
  try {
    window.history.pushState('', searchTargetUrl, searchTargetUrl + '?' + searchParams);
  } catch (e) {
  }
};

export {
  resetFilters,
  applyFilters,
  applyHistory,
  maybeApplyFilters,
};
